import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: "20px"
  },
  endlist: {
    textAlign: "center",
    marginTop: "80px",
    color: theme.palette.notFoundBrown,
    ...theme.typography.h5
  }
}));
